import React, { PureComponent } from "react";
import { Table, Select } from 'element-react';
import { Link } from "react-router-dom";

import "./index.scss";

export default class Index extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      value: '',
      navList: [
        {
          title: '政务服务',
          href: '#a01'
        },
        {
          title: '动态资讯',
          href: '#a02'
        },
        {
          title: '优惠服务',
          href: '#a03'
        },
        {
          title: '政策法规',
          href: '#a04'
        },
        {
          title: '军旅文化',
          href: '#a05'
        },
        {
          title: '服务中心',
          href: '#a06'
        },
      ],
      active: '0'
    };
  }


  componentDidMount() {
  }

  clickActive = (index) => {
    this.setState({
      active: index
    })
  }

  render() {
    let { navList, active } = this.state;
    return (
      <div className="searchResult" style={{ backgroundColor: '#fff', marginTop: '-20px' }}>
        <div className="searchResult_nav clear">
          <ul>
            {
              navList && navList.map((item, index) => {
                return <li className={active == index ? "active" : null} onClick={() => this.clickActive(index)}><a href={item.href} key={index}>{item.title}</a></li>
              })
            }
          </ul>
        </div>
        <div className="container" id="a01">
          <div className="affairsService">
            <div className="present">当前搜索范围：海南省&nbsp;&nbsp;&nbsp;海口市</div>
            <div className="affairsService_list">
              <div className="affairsService_list_title clear">
                <span>政务服务</span>
                <span>搜索到相关结果约22条</span>
              </div>
              <ul>
                <li className="clear">
                  <div className="affairsService_list_left">全国优抚事业单位改革发展座谈会在京召开</div>
                  <div className="affairsService_list_right">
                    <Link to="/preferential/applicationProcess">在线办理</Link>
                    <Link to="/preferential/applicationGuide?1250261663748227074">办事指南</Link>
                  </div>
                </li>
                <li className="clear">
                  <div className="affairsService_list_left">全国优抚事业单位改革发展座谈会在京召开</div>
                  <div className="affairsService_list_right">
                    <Link to="/preferential/applicationProcess">在线办理</Link>
                    <Link to="/preferential/applicationGuide?1250261663748227074">办事指南</Link>
                  </div>
                </li>
                <li className="clear">
                  <div className="affairsService_list_left">全国优抚事业单位改革发展座谈会在京召开</div>
                  <div className="affairsService_list_right">
                    <Link to="/preferential/applicationProcess">在线办理</Link>
                    <Link to="/preferential/applicationGuide?1250261663748227074">办事指南</Link>
                  </div>
                </li>
                <li className="clear">
                  <div className="affairsService_list_left">全国优抚事业单位改革发展座谈会在京召开</div>
                  <div className="affairsService_list_right">
                    <Link to="/preferential/applicationProcess">在线办理</Link>
                    <Link to="/preferential/applicationGuide?1250261663748227074">办事指南</Link>
                  </div>
                </li>
                <li className="clear">
                  <div className="affairsService_list_left">全国优抚事业单位改革发展座谈会在京召开</div>
                  <div className="affairsService_list_right">
                    <Link to="/preferential/applicationProcess">在线办理</Link>
                    <Link to="/preferential/applicationGuide?1250261663748227074">办事指南</Link>
                  </div>
                </li>
                <li className="clear">
                  <div className="affairsService_list_left">全国优抚事业单位改革发展座谈会在京召开</div>
                  <div className="affairsService_list_right">
                    <Link to="/preferential/applicationProcess">在线办理</Link>
                    <Link to="/preferential/applicationGuide?1250261663748227074">办事指南</Link>
                  </div>
                </li>
                <li className="clear">
                  <div className="affairsService_list_left">全国优抚事业单位改革发展座谈会在京召开</div>
                  <div className="affairsService_list_right">
                    <Link to="/preferential/applicationProcess">在线办理</Link>
                    <Link to="/preferential/applicationGuide?1250261663748227074">办事指南</Link>
                  </div>
                </li>
                <li className="clear">
                  <div className="affairsService_list_left">全国优抚事业单位改革发展座谈会在京召开</div>
                  <div className="affairsService_list_right">
                    <Link to="/preferential/applicationProcess">在线办理</Link>
                    <Link to="/preferential/applicationGuide?1250261663748227074">办事指南</Link>
                  </div>
                </li>
                <li className="clear">
                  <div className="affairsService_list_left">全国优抚事业单位改革发展座谈会在京召开</div>
                  <div className="affairsService_list_right">
                    <Link to="/preferential/applicationProcess">在线办理</Link>
                    <Link to="/preferential/applicationGuide?1250261663748227074">办事指南</Link>
                  </div>
                </li>
                <li className="clear">
                  <div className="affairsService_list_left">全国优抚事业单位改革发展座谈会在京召开</div>
                  <div className="affairsService_list_right">
                    <Link to="/preferential/applicationProcess">在线办理</Link>
                    <Link to="/preferential/applicationGuide?1250261663748227074">办事指南</Link>
                  </div>
                </li>
              </ul>
              <div className="more_btn">查看更多</div>
            </div>
          </div>
        </div>

        <div className="container" id="a02">
          <div className="affairsService">
            <div className="affairsService_list">
              <div className="affairsService_list_title clear">
                <span>动态资讯</span>
                <span>搜索到相关结果0条</span>
              </div>
              <div className="none">无</div>
            </div>
          </div>
        </div>

        <div className="container" id="a03">
          <div className="affairsService">
            <div className="affairsService_list">
              <div className="affairsService_list_title clear">
                <span>优惠服务</span>
                <span>搜索到相关结果0条</span>
              </div>
              <div className="none">无</div>
            </div>
          </div>
        </div>

        <div className="container" id="a04">
          <div className="affairsService">
            <div className="affairsService_list">
              <div className="affairsService_list_title clear">
                <span>政策法规</span>
                <span>搜索到相关结果约2条</span>
              </div>
              <ul>
                <li className="clear">
                  <div className="affairsService_list_left">全国优抚事业单位改革发展座谈会在京召开</div>
                </li>
                <li className="clear">
                  <div className="affairsService_list_left">全国优抚事业单位改革发展座谈会在京召开</div>
                </li>
              </ul>
              <div className="more_btn">查看更多</div>
            </div>
          </div>
        </div>

        <div className="container" id="a05">
          <div className="affairsService">
            <div className="affairsService_list">
              <div className="affairsService_list_title clear">
                <span>军旅文化</span>
                <span>搜索到相关结果0条</span>
              </div>
              <div className="none">无</div>
            </div>
          </div>
        </div>
        <div className="container" id="a06" style={{ marginBottom: '80px' }}>
          <div className="affairsService">
            <div className="affairsService_list">
              <div className="affairsService_list_title clear">
                <span>服务中心</span>
                <span>搜索到相关结果0条</span>
              </div>
              <div className="none">无</div>
            </div>
          </div>
        </div>
      </div >
    );
  }
}
